export const OFFLINE_COMPONENT_TRANSLATIONS = {
  bannerOfflineMessage: {
    "pt-BR": "Você está offline. Alterações serão sincronizadas quando a conexão voltar.",
    en: "You are offline. Changes will sync when the connection is restored.",
    es: "Estás sin conexión. Los cambios se sincronizarán cuando vuelva internet.",
    de: "Du bist offline. Die Änderungen werden synchronisiert, sobald die Verbindung wiederhergestellt ist.",
  },
  bannerSyncing: {
    "pt-BR": "Sincronizando alterações…",
    en: "Syncing changes…",
    es: "Sincronizando cambios…",
    de: "Änderungen werden synchronisiert…",
  },
  bannerPendingCount: {
    "pt-BR": "{count} alteração(ões) pendente(s) de sincronização.",
    en: "{count} change(s) pending sync.",
    es: "{count} cambio(s) pendiente(s) de sincronización.",
    de: "{count} Änderung(en) warten auf Synchronisierung.",
  },
  bannerFailedCount: {
    "pt-BR": "{count} alteração(ões) não sincronizada(s). Revise com conexão estável.",
    en: "{count} change(s) failed to sync. Review with a stable connection.",
    es: "{count} cambio(s) no sincronizado(s). Revísalo con conexión estable.",
    de: "{count} Änderungen konnten nicht synchronisiert werden. Überprüfen Sie es mit einer stabilen Verbindung.",
  },
  gateDefaultReason: {
    "pt-BR": "Disponível apenas com internet.",
    en: "Available only with internet.",
    es: "Disponible solo con internet.",
    de: "Nur mit Internet verfügbar.",
  },
} as const;
